/**
 * Account settings: pure validation.
 *
 * Mirrors the rules the flat `Profile` page enforced via the `required` inputs:
 * all three identity fields required, plus an email-format check via the shared
 * `isValidEmail`. Pure (no React/Redux/fetch) so it is unit-tested directly
 * and reused by the slice's selectors and the saga.
 */
import { isValidEmail } from '@/utils/validation';

import type { AccountDraft, ValidationErrors } from './account-draft.model';

export function validateDraft(draft: AccountDraft): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!draft.firstName.trim()) errors.firstName = 'First name is required.';
  if (!draft.lastName.trim()) errors.lastName = 'Last name is required.';

  if (!draft.email.trim()) {
    errors.email = 'Email is required.';
  } else if (!isValidEmail(draft.email)) {
    errors.email = 'Please enter a valid email address.';
  }

  return errors;
}
